var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "passportInfoContainer",
      on: {
        input: function($event) {
          _vm.$emit("input", _vm.passport)
        },
        change: function($event) {
          _vm.onChange(_vm.passport)
        }
      }
    },
    [
      _c(
        "f9field",
        [
          _c(
            "div",
            {
              staticClass: "passport-label-flex",
              attrs: { slot: "label" },
              slot: "label"
            },
            [
              _c("label", { attrs: { for: "passport-number" } }, [
                _c("span", { staticClass: "slider-label" }, [
                  _vm._v("Passport Number*")
                ])
              ]),
              _vm._v(" "),
              _vm.allowRemove
                ? _c(
                    "f9button",
                    {
                      staticClass: "removePassportContainer",
                      attrs: { nostyle: "" },
                      on: {
                        click: function($event) {
                          _vm.removePassport(_vm.passport)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "addRemovePassport" }, [
                        _vm._v("Remove passport")
                      ]),
                      _c("img", {
                        attrs: {
                          src: require("images/Loyalty/Icons/remove.svg"),
                          alt: ""
                        }
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("f9input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value:
                  (!_vm.notRequired ? "required|" : "") + "alpha_num|max:35",
                expression:
                  "(!notRequired ? 'required|' : '') +'alpha_num|max:35'"
              }
            ],
            attrs: {
              saved: !_vm.changed,
              "data-vv-scope": _vm.validationScope,
              name: "passport_number"
            },
            model: {
              value: _vm.passport.documentNumber,
              callback: function($$v) {
                _vm.$set(_vm.passport, "documentNumber", $$v)
              },
              expression: "passport.documentNumber"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "f9field",
        { attrs: { label: "Issuing Country*" } },
        [
          _c(
            "f9select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: !_vm.notRequired ? "required" : "",
                  expression: "!notRequired ? 'required' : ''"
                }
              ],
              attrs: {
                saved: !_vm.changed,
                "data-vv-scope": _vm.validationScope,
                name: "passport_issuing_country"
              },
              model: {
                value: _vm.passport.issuingCountry,
                callback: function($$v) {
                  _vm.$set(_vm.passport, "issuingCountry", $$v)
                },
                expression: "passport.issuingCountry"
              }
            },
            _vm._l(_vm.member.resourceData.countries, function(item) {
              return _c(
                "option",
                {
                  key: item.code,
                  attrs: { "data-cs-mask": "" },
                  domProps: { value: item.code }
                },
                [_vm._v(_vm._s(item.name))]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "f9field",
        { attrs: { label: "Nationality*" } },
        [
          _c(
            "f9select",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: !_vm.notRequired ? "required" : "",
                  expression: "!notRequired ? 'required' : ''"
                }
              ],
              attrs: {
                saved: !_vm.changed,
                "data-vv-scope": _vm.validationScope,
                name: "passport_issuing_nationality"
              },
              model: {
                value: _vm.passport.nationality,
                callback: function($$v) {
                  _vm.$set(_vm.passport, "nationality", $$v)
                },
                expression: "passport.nationality"
              }
            },
            _vm._l(_vm.member.resourceData.countries, function(item) {
              return _c(
                "option",
                {
                  key: item.code,
                  attrs: { "data-cs-mask": "" },
                  domProps: { value: item.code }
                },
                [_vm._v(_vm._s(item.name))]
              )
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "slider-form-row" },
        [
          _vm.displayIssueDate
            ? _c(
                "f9field",
                { attrs: { label: "Issue Date*", half: "" } },
                [
                  _c("f9date", {
                    attrs: {
                      saved: !_vm.changed,
                      "open-date": _vm.today,
                      name: "passport_issue_date",
                      "data-vv-scope": _vm.validationScope,
                      required: !_vm.notRequired
                    },
                    model: {
                      value: _vm.passport.issueDate,
                      callback: function($$v) {
                        _vm.$set(_vm.passport, "issueDate", $$v)
                      },
                      expression: "passport.issueDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "f9field",
            { attrs: { label: "Expiration Date*", half: "" } },
            [
              _c("f9date", {
                attrs: {
                  saved: !_vm.changed,
                  "open-date": _vm.today,
                  name: "passport_expiry_date",
                  "data-vv-scope": _vm.validationScope,
                  "min-date": _vm.today,
                  "max-date": _vm.maxExpirationDate,
                  required: !_vm.notRequired
                },
                model: {
                  value: _vm.passport.expirationDate,
                  callback: function($$v) {
                    _vm.$set(_vm.passport, "expirationDate", $$v)
                  },
                  expression: "passport.expirationDate"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a86a2f2", { render: render, staticRenderFns: staticRenderFns })
  }
}